import { useGoogleOptimizeExperimentId } from "contexts/DataContext/hooks";
import { useDeviceSize } from "hooks";
import { useGoogleOptimize } from "hooks/useGoogleOptimize";
import { AutocompleteForm } from "modules/common/components/AutocompleteForm";
import { NewWayOfClaimingDesktop, NewWayOfClamingMobile } from "modules/experiments/NewWayOfClaiming";
import type { HeroFormProps } from "./HeroForm.d";
import InfoCheckmarks from "./InfoCheckmarks/InfoCheckmarks";

const MOBILE_EXPERIMENT_NAME = "new-way-of-claiming";
const DESKTOP_EXPERIMENT_NAME = "new-way-of-claiming-desktop";

const HeroForm = ({ ctaVariant = "primary", buttonText = undefined, checkmarks = [] }: HeroFormProps) => {
  const { isMobile, isTabletOrDesktop } = useDeviceSize();
  const mobileExperimentId = useGoogleOptimizeExperimentId(MOBILE_EXPERIMENT_NAME);
  const desktopExperimentId = useGoogleOptimizeExperimentId(DESKTOP_EXPERIMENT_NAME);
  const mobileExperimentVariant = useGoogleOptimize(mobileExperimentId);
  const desktopExperimentVariant = useGoogleOptimize(desktopExperimentId);

  const FormVariant = (() => {
    if (isMobile && Number(mobileExperimentVariant) === 1) return <NewWayOfClamingMobile />;
    if (isTabletOrDesktop && Number(desktopExperimentVariant) === 1) return <NewWayOfClaimingDesktop />;
    return <AutocompleteForm ctaVariant={ctaVariant} buttonText={buttonText} />;
  })();

  return (
    <>
      {FormVariant}
      <InfoCheckmarks checkmarks={checkmarks} />
    </>
  );
};

export default HeroForm;
